import { Skeleton as MuiSkeleton, Stack } from '@mui/material'

const Skeleton = () => {
    return (
        <Stack spacing={1}>
            <MuiSkeleton variant="text" sx={{ fontSize: '2rem', width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />
            <MuiSkeleton variant="rounded" width="100%" height={800} sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />
        </Stack>
    )
}

export default Skeleton